// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Home20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Home20: FC<Home20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M5.5 15.5h2v-5h5v5h2V8.25L10 4.875 5.5 8.25v7.25ZM4 17V7.5L10 3l6 4.5V17h-5v-5H9v5H4Z" />
        </svg>
    );
};

export default Home20;
